export const stepperInventoryControl = {
	steps: {
		config: "Configuración",
		count: "Listado y conteo",
		adjustLoss: "Ajustes y pérdidas",
		resumeInventory: "Resumen del inventario",
		approval: "Aprobación",
	},
	stepsDescription: {
		count: "Guarde el inventario durante el llenado para no perder su avance",
		resumeInventory: "Revise los elementos contados antes de enviar",
	},
	fieldRequired: "Campo obligatorio",
};
